import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const PencilFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function PencilFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M17.337 2.662c1.1-1.1 2.9-1.1 4 0s1.1 2.9 0 4l-1.29 1.29-4-4 1.29-1.29ZM1.837 22.163l.01-4.01 12.78-12.78 4 4-12.78 12.78-4.01.01Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default PencilFilled;